exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._15F9P-7_3_0 {\n  color: #808080;\n  display: flex;\n  font-size: 13px;\n  align-items: center; }\n  ._15F9P-7_3_0 a,\n  ._15F9P-7_3_0 a:hover {\n    text-decoration: none; }\n  ._3b_y5-7_3_0 {\n    color: #808080;\n    text-decoration: none; }\n    ._3b_y5-7_3_0:hover {\n      color: #808080;\n      text-decoration: underline; }\n    ._3b_y5-7_3_0._2SIJi-7_3_0 {\n      color: #4d4d4d;\n      font-weight: bold;\n      text-decoration: none; }\n  ._3Zp9B-7_3_0 {\n    margin: 0px 8px; }\n", ""]);

// Exports
exports.locals = {
	"core-breadcrumbs": "_15F9P-7_3_0",
	"core-breadcrumbs__crumb": "_3b_y5-7_3_0",
	"core-breadcrumbs__crumb--active": "_2SIJi-7_3_0",
	"core-breadcrumbs__separator": "_3Zp9B-7_3_0"
};